import OnlyHeader from "components/Layout/OnlyHeader";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ReactSwitch from "react-switch";
import {
  Row,
  Container,
  Card,
  Col,
  Input,
  Button,
  Form,
  Spinner,
  Label,
  FormGroup,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { addForwardFees } from "store/actions/settingAction";
import { updateForwardFees } from "store/actions/settingAction";
import { addPaymentConnections } from "store/actions/settingAction";
import { addPaymentMethodDetails } from "store/actions/settingAction";
import { getForwardFees } from "store/actions/settingAction";
import { getRestaurantCurrency } from "store/actions/orderActions";
import { getTutorials } from "store/actions/tutorialsActions";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { removePaymentMethodDetails } from "store/actions/settingAction";
import PaymentConnectionTable from "../components/Settings/PaymentConnection/PaymentConnectionTable";
import { toast } from "react-toastify";

function PaymentConnection() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { tutorials } = useSelector((state) => state.tutorials);
  const { user, uid } = useSelector((state) => state.auth);
  const { restaurantCurrency } = useSelector((state) => state.requests);
  const { loading } = useSelector((state) => state.catalog);
  const {
    forwardFee,
    addForwardFeesLoader,
    updateForwardFeesLoader,
    removePaymentLoader,
    paymentConnectionLoading
  } = useSelector((state) => state.setting);

  const [modal, setModal] = useState(false);
  const [show, setshow] = useState(false);
  const [checkedCards, setCheckedCards] = useState([]);
  const [paypalFormData, setPaypalFormData] = useState({
    paypalClientKey: "",
    paypalSecretKey: ""
  });
  const [stripeFormData, setStripeFormData] = useState({
    stripeClientKey: "",
    stripeSecretKey: ""
  });
  const [paymentType, setPaymentType] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [methodName, setMethodName] = useState("paypal");
  const [value, setValue] = useState("");
  const [percentageValue, setPercentageValue] = useState("");
  const [isExist, setIsExist] = useState(null);
  const [index, setIndex] = useState(null);
  const [checked, setChecked] = useState(forwardFee?.length == 2);
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const [deletePaypal, setDeletePaypal] = useState(false);
  const [deleteStripe, setDeleteStripe] = useState(false);
  const payModalToggle = () => setModal(!modal);
  const [missingMethods, setMissingMethods] = useState([]);
  const handleClick = () => setshow(!show);
  const deletePaypalToggle = () => setDeletePaypal((prev) => !prev);

  const paymentList = [
    { value: "paypal", label: "Paypal" },
    { value: "stripe", label: "Stripe" }
  ];

  const paypalLink = tutorials.find(
    (tutorial) => tutorial.title === "Paypal Integration"
  )?.video;

  const stripeLink = tutorials.find(
    (tutorial) => tutorial.title === "Stripe Integration"
  )?.video;

  const filteredPaymentList = paymentList.filter(
    (payment) =>
      !forwardFee?.some((fee) => fee.provider === payment.value) &&
      user?.paymentConnections?.[payment.value]
  );

  const deleteStripeToggle = () => {
    setDeleteStripe((prev) => !prev);
  };

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
  };

  const toggleTab = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const handleForwardFee = (evt) => {
    evt.preventDefault();

    if (!user?.paymentConnections?.[paymentMethod]) {
      toast.error(`Please setup ${paymentMethod} credentials first`);
      return;
    }

    let obj = {
      fixedAmount: "",
      percentageAmount: "",
      provider: paymentMethod,
      type: paymentType
    };

    if (paymentType === "both") {
      obj.fixedAmount = value;
      obj.percentageAmount = percentageValue;
    } else if (paymentType === "percentage") {
      obj.percentageAmount = value;
    } else {
      obj.fixedAmount = value;
    }

    if (isExist) {
      dispatch(
        updateForwardFees(uid, index, obj, () => {
          setPaymentMethod("");
          setPaymentType("");
          setValue("");
          setPercentageValue("");
          setIsExist(null);
          setIndex(null);
        })
      );
    } else {
      dispatch(
        addForwardFees(uid, obj, () => {
          setPaymentMethod("");
          setPaymentType("");
          setValue("");
          setPercentageValue("");
        })
      );
    }
  };

  const handlePaypalFormInput = (e) => {
    const { name, value } = e.target;
    setPaypalFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handlePaypalFormSubmit = (e) => {
    e.preventDefault();
    dispatch(addPaymentConnections(uid, methodName, () => {}));
    dispatch(
      addPaymentMethodDetails(uid, paypalFormData, "paypal", () => {
        setPaypalFormData("");
      })
    );
  };

  const handleStripeFormInput = (e) => {
    const { name, value } = e.target;
    setStripeFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleStripeFormSubmit = (e) => {
    e.preventDefault();
    dispatch(addPaymentConnections(uid, methodName, () => {}));
    dispatch(addPaymentMethodDetails(uid, stripeFormData, "stripe", () => {}));
  };

  const handleRemoveStripePayment = (e) => {
    e.preventDefault();
    dispatch(
      removePaymentMethodDetails(uid, methodName, () => {
        deleteStripeToggle();
        setStripeFormData({
          stripeClientKey: "",
          stripeSecretKey: ""
        });
      })
    );
  };

  const handleRemovePaypalPayment = (e) => {
    e.preventDefault();
    dispatch(
      removePaymentMethodDetails(uid, methodName, () => {
        deletePaypalToggle();
        setPaypalFormData({
          paypalClientKey: "",
          paypalSecretKey: ""
        });
      })
    );
  };

  const handleChangeValue = (value) => {
    if (value >= 0) {
      setValue(value);
    } else {
      setValue("");
    }
  };
  const isSubmitDisabled = () => {
    if (
      paypalFormData.paypalSecretKey === "" ||
      paypalFormData.paypalClientKey === ""
    ) {
      return true;
    } else if (paypalFormData.paypalSecretKey === user?.paypalSecretKey) {
      return true;
    } else {
      return false;
    }
  };

  const isSubmitDisabledStripe = () => {
    if (
      stripeFormData?.stripeClientKey === "" ||
      stripeFormData?.stripeSecretKey === ""
    ) {
      return true;
    } else if (stripeFormData.stripeSecretKey === user?.stripeSecretKey) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (user?.forwardFees) {
      let obj = user?.forwardFees?.find(
        (ele) => ele?.provider === paymentMethod
      );
      if (obj) {
        setIsExist(obj);
        setPaymentType(obj?.type);
        setValue(obj?.amount);
      } else {
        setIsExist(null);
      }
      let indexVal = user?.forwardFees?.findIndex(
        (ele) => ele?.provider === paymentMethod
      );
      if (indexVal === "-1") {
        setIndex(null);
      } else {
        setIndex(indexVal);
      }
    }
  }, [paymentMethod, user?.forwardFees]);

  useEffect(() => {
    if (user?.paymentConnections) {
      if (user?.paymentConnections?.paypal && !checkedCards.includes("1")) {
        setCheckedCards((prevCheckedCards) => [...prevCheckedCards, "1"]);
      }
      if (user?.paymentConnections?.stripe && !checkedCards.includes("2")) {
        setCheckedCards((prevCheckedCards) => [...prevCheckedCards, "2"]);
      }
      if (!user?.paymentConnections?.paypal) {
        setPaymentMethod((prev) => (prev === "paypal" ? "" : prev));
      }
      if (!user?.paymentConnections?.stripe) {
        setPaymentMethod((prev) => (prev === "stripe" ? "" : prev));
      }
      if (user?.paypalClientKey) {
        setPaypalFormData((prevState) => ({
          ...prevState,
          paypalClientKey: user?.paypalClientKey
        }));
      }
      if (user?.paypalSecretKey) {
        setPaypalFormData((prevState) => ({
          ...prevState,
          paypalSecretKey: user?.paypalSecretKey
        }));
      }
      if (user?.stripeClientKey) {
        setStripeFormData((prevState) => ({
          ...prevState,
          stripeClientKey: user?.stripeClientKey
        }));
      }
      if (user?.stripeSecretKey) {
        setStripeFormData((prevState) => ({
          ...prevState,
          stripeSecretKey: user?.stripeSecretKey
        }));
      }
    }
  }, [checkedCards, user]);

  useEffect(() => {
    dispatch(getTutorials());
    dispatch(getForwardFees(user?.restaurantID));
  }, [dispatch, user?.restaurantID]);

  useEffect(() => {
    if (forwardFee?.length == 2) {
      setChecked(true);
    }
  }, [forwardFee]);

  useEffect(() => {
    const missing = [];
    if (!user?.paymentConnections?.paypal) missing.push("PayPal");
    if (!user?.paymentConnections?.stripe) missing.push("Stripe");
    setMissingMethods(missing);
  }, [user?.paymentConnections]);

  useEffect(() => {
    dispatch(getRestaurantCurrency(user?.restaurantID));
  }, [dispatch, user?.restaurantID]);

  return (
    <>
      <OnlyHeader />
      <Container fluid className="mt--7">
        <div className="col">
          <Card className="shadow">
            <Row className="d-flex align-items-center justify-content-between mx-0 mt-4 flex-wrap">
              <Col
                lg="auto"
                md="12"
                className="d-flex align-items-center mb-2 mb-md-0"
              >
                <Button
                  size="sm"
                  color="primary"
                  onClick={() => {
                    history.push("/admin/settings/client-setting-menu");
                  }}
                >
                  <i className="fas fa-arrow-left "></i>
                </Button>

                <h4 className="text-center mt-2 ml-2 d-flex flex-nowrap">
                  Payment Collection
                </h4>
              </Col>

              <Col
                md="12"
                lg="auto"
                className="d-flex align-items-center justify-content-end"
              >
                <ReactSwitch
                  onChange={handleChange}
                  checked={checked}
                  className="react-switch"
                />
                {!checked && (
                  <span className="ml-2 d-flex flex-flex-nowrap fs-12">
                    Forward Fee to Client
                  </span>
                )}
              </Col>
            </Row>

            <hr></hr>

            {((missingMethods?.length == 1 && forwardFee?.length == 0) ||
              (missingMethods?.length == 0 && forwardFee?.length == 0) ||
              (missingMethods?.length == 0 && forwardFee?.length == 1)) && (
              <Row className="pb-4 mt--2">
                <Col className="d-flex justify-content-center align-items-center">
                  {checked && (
                    <Col
                      xs="12"
                      md="10"
                      lg="8"
                      className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2"
                    >
                      <Input
                        type="select"
                        className="flex-fill mb-2 mx-md-1 mx-0"
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        style={{ minHeight: "38px" }}
                      >
                        <option value="" disabled>
                          Select Payment Method
                        </option>
                        {filteredPaymentList.map((payment) => (
                          <option key={payment.value} value={payment.value}>
                            {payment.label}
                          </option>
                        ))}
                      </Input>

                      <Input
                        type="select"
                        className="flex-fill mb-2 mx-md-1 mx-0"
                        value={paymentType}
                        onChange={(e) => setPaymentType(e.target.value)}
                        style={{ minHeight: "38px" }}
                      >
                        <option value="" disabled>
                          Payment Type
                        </option>
                        <option value="percentage">Percentage</option>
                        <option value="fixed_price">Fixed Price</option>
                        <option value="both">Both</option>
                      </Input>

                      {paymentType === "both" && (
                        <Input
                          type="number"
                          min={0}
                          step="any"
                          className="flex-fill mb-2 mx-md-1 mx-0"
                          value={percentageValue}
                          onChange={(e) => setPercentageValue(e.target.value)}
                          placeholder="Percentage"
                          style={{ minHeight: "38px" }}
                        />
                      )}

                      <Input
                        type="number"
                        min={0}
                        step="any"
                        className="flex-fill mb-2 mx-md-1 mx-0"
                        value={value}
                        onChange={(e) => handleChangeValue(e.target.value)}
                        placeholder={`Enter Fee ${restaurantCurrency}`}
                        style={{ minHeight: "38px" }}
                      />

                      <Button
                        color="primary"
                        className="btn-md flex-fill mb-2 mx-md-1 mx-0"
                        type="submit"
                        onClick={handleForwardFee}
                        disabled={
                          loading ||
                          !paymentMethod ||
                          !paymentType ||
                          !value ||
                          !user?.paymentConnections?.[paymentMethod] ||
                          addForwardFeesLoader ||
                          updateForwardFeesLoader
                        }
                      >
                        {addForwardFeesLoader ? <Spinner size="sm" /> : "Save"}
                      </Button>
                    </Col>
                  )}
                </Col>
              </Row>
            )}

            {missingMethods.length > 0 && checked && (
              <div className="text-warning px-2 mb-4 d-flex justify-content-center align-items-center ">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                <small>
                  Please add keys for {missingMethods.join(" and ")} to add
                  Payments for clients
                </small>
              </div>
            )}

            {checked && (
              <Row>
                <Col>
                  {" "}
                  <PaymentConnectionTable
                    forwardFee={forwardFee}
                    restaurantCurrency={restaurantCurrency}
                  />
                </Col>
              </Row>
            )}
            {!checked && (
              <div className=" px-2 d-flex justify-content-center align-items-center ">
                <small className="text-info">
                  Please Toggle Button to Forward Fee to Client
                </small>
              </div>
            )}

            <div className="d-flex justify-content-center">
              <div
                style={{
                  display: "block",
                  width: 700,
                  padding: 30
                }}
                className="flex justify-content-center"
              >
                <Row></Row>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: currentActiveTab === "1",
                        "cursor-pointer": true
                      })}
                      onClick={() => {
                        setMethodName("paypal");
                        toggleTab("1");
                      }}
                    >
                      Paypal
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: currentActiveTab === "2",
                        "cursor-pointer": true
                      })}
                      onClick={() => {
                        setMethodName("stripe");
                        toggleTab("2");
                      }}
                    >
                      Stripe
                    </NavLink>
                  </NavItem>
                  <Col className="d-flex justify-content-end mb-2">
                    <Button color="primary" size="sm" onClick={payModalToggle}>
                      View Tutorial
                    </Button>
                  </Col>
                </Nav>
                <TabContent activeTab={currentActiveTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Col sm="12">
                        <Form onSubmit={handlePaypalFormSubmit}>
                          <Row>
                            <Col className=" py-3 d-flex flex-column align-items-center">
                              <i className="fab fa-cc-paypal fa-5x pointer"></i>
                            </Col>
                          </Row>
                          <h2 className="py-2">
                            Enter Paypal Payment Method Details
                          </h2>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="paypalClientKey">
                                  Paypal Client ID
                                </Label>
                                <Input
                                  className="border border-light"
                                  id="paypalClientKey"
                                  name="paypalClientKey"
                                  placeholder="Enter Paypal Client ID"
                                  type="text"
                                  value={paypalFormData.paypalClientKey}
                                  onChange={(event) => {
                                    handlePaypalFormInput(event);
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="paypalSecretKey">
                                  Paypal Client Secret
                                </Label>
                                <InputGroup className="border border-light">
                                  <Input
                                    className="border-0"
                                    id="paypalSecretKey"
                                    name="paypalSecretKey"
                                    placeholder="Enter Paypal Client Secret"
                                    type={show ? "text" : "password"}
                                    value={paypalFormData.paypalSecretKey}
                                    onChange={(event) => {
                                      handlePaypalFormInput(event);
                                    }}
                                  />
                                  <span
                                    className="mt-2 mr-1 border-0 px-2 text-default rounded-pill"
                                    onClick={handleClick}
                                  >
                                    {" "}
                                    {show ? (
                                      <small>
                                        <i className="fas fa-eye-slash text-muted"></i>
                                      </small>
                                    ) : (
                                      <small>
                                        <i className="fas fa-eye text-muted"></i>
                                      </small>
                                    )}
                                  </span>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-between">
                            <Button
                              type="submit"
                              color="primary"
                              disabled={
                                isSubmitDisabled() ||
                                paymentConnectionLoading ||
                                removePaymentLoader
                              }
                            >
                              {paymentConnectionLoading ? (
                                <Spinner size="sm" />
                              ) : (
                                <>
                                  {user?.paymentConnections?.paypal
                                    ? "Update"
                                    : "Submit"}
                                </>
                              )}
                            </Button>
                            <Button
                              onClick={deletePaypalToggle}
                              className="d-flex justify-content-end"
                              color="danger"
                              disabled={
                                !user?.paymentConnections?.paypal ||
                                removePaymentLoader ||
                                paymentConnectionLoading
                              }
                            >
                              Remove
                            </Button>
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="2">
                    <Row>
                      <Col sm="12">
                        <Form onSubmit={handleStripeFormSubmit}>
                          <Row>
                            <Col className=" py-3 d-flex flex-column align-items-center">
                              <i className="fab fa-cc-stripe fa-5x pointer"></i>
                            </Col>
                          </Row>
                          <h2 className="py-2">
                            Enter Stripe Payment Method Details
                          </h2>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="stripeClientKey">
                                  Stripe Client ID
                                </Label>
                                <Input
                                  className="border border-light"
                                  id="stripeClientKey"
                                  name="stripeClientKey"
                                  placeholder="Enter Stripe Client ID"
                                  type="text"
                                  value={stripeFormData.stripeClientKey}
                                  onChange={handleStripeFormInput}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="stripeSecretKey">
                                  Stripe Client Secret
                                </Label>
                                <InputGroup className="border border-light">
                                  <Input
                                    className="border-0"
                                    id="stripeSecretKey"
                                    name="stripeSecretKey"
                                    placeholder="Enter Stripe Client Secret"
                                    type={show ? "text" : "password"}
                                    value={stripeFormData.stripeSecretKey}
                                    onChange={handleStripeFormInput}
                                  />
                                  <Link
                                    role="button"
                                    className="mt-2 mr-1 px-2 text-default rounded-pill"
                                    onClick={handleClick}
                                  >
                                    {" "}
                                    {show ? (
                                      <small>
                                        <i className="fas fa-eye-slash text-muted"></i>
                                      </small>
                                    ) : (
                                      <small>
                                        <i className="fas fa-eye text-muted"></i>
                                      </small>
                                    )}
                                  </Link>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-between">
                            <Button
                              type="submit"
                              color="primary"
                              disabled={isSubmitDisabledStripe()}
                            >
                              {paymentConnectionLoading ? (
                                <Spinner size="sm" />
                              ) : (
                                <>
                                  {user?.paymentConnections?.stripe
                                    ? "Update"
                                    : "Submit"}
                                </>
                              )}
                            </Button>
                            <Button
                              onClick={deleteStripeToggle}
                              className="d-flex justify-content-end"
                              color="danger"
                              disabled={!user?.paymentConnections?.stripe}
                            >
                              Remove
                            </Button>
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </div>
            <hr></hr>

            {/*  */}
          </Card>
        </div>
        <Modal isOpen={modal} toggle={payModalToggle} centered={true} size="lg">
          <ModalHeader toggle={payModalToggle}>
            <h4>
              {currentActiveTab === "1" ? "Paypal " : "Stripe "}
              integration Tutorial
            </h4>
          </ModalHeader>

          <ModalBody>
            <Card className="tutorials__card">
              <video controls muted className="tutorials__card-media rounded">
                <source
                  src={
                    currentActiveTab === "1"
                      ? paypalLink || ""
                      : stripeLink || ""
                  }
                  type="video/mp4"
                />
              </video>
            </Card>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={payModalToggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </Container>

      <ConfirmationModal
        title="Delete Paypal"
        text="Are you sure you want to remove payment detail of Paypal"
        isOpen={deletePaypal}
        toggle={deletePaypalToggle}
        isLoading={removePaymentLoader}
        onConfirmation={handleRemovePaypalPayment}
      />
      <ConfirmationModal
        title="Delete Stripe"
        text="Are you sure you want to remove payment detail of Stripe"
        isOpen={deleteStripe}
        toggle={deleteStripeToggle}
        isLoading={removePaymentLoader}
        onConfirmation={handleRemoveStripePayment}
      />
    </>
  );
}

export default PaymentConnection;
